import { cosmiconfig } from 'cosmiconfig'
import { z } from 'zod'

const explorer = cosmiconfig('components')

const rawConfigSchema = z.object({
  useSrcDir: z.boolean(),
  alias: z.string().optional(),
})

export type RawConfig = z.infer<typeof rawConfigSchema>

export async function getConfig(cwd = process.cwd()): Promise<RawConfig | null> {
  try {
    const result = await explorer.search(cwd)

    if (!result) {
      return null
    }
    return rawConfigSchema.parse(result)
  } catch (error) {
    throw new Error(
      `Error loading components.json configuration: ${error instanceof Error ? error.message : 'Unknown error'}`
    )
  }
}
